<template>
  <q-layout view="hHh Lpr fFf">
    <q-header reveal elevated class="bg-primary">
      <q-toolbar shrink>
        <q-toolbar-title class="q-mr-sm">
          <q-avatar>
            <img alt="logo" src="@/assets/logo.svg" />
          </q-avatar>
          {{ $t('productID') }}
        </q-toolbar-title>
        <q-select
          v-model="locale"
          :options="localeOptions"
          :label="$t('language')"
          dense
          borderless
          emit-value
          map-options
          options-dense
          filled
          fill-input
          class="q-mr-sm locale-select"
          style="min-width: 100px"
          dropdown-icon="mdi-menu-down"
          @update:model-value="changeLanguage"
        />
        <q-btn dense flat round icon="mdi-theme-light-dark" size="18px" @click="toggleDarkMode"
               class="q-mr-sm" />
      </q-toolbar>
    </q-header>
    <q-page-container style="padding-top: 0">
      <router-view />
    </q-page-container>
  </q-layout>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useQuasar } from 'quasar';
import { useSettingsStore } from '@/stores/settings';

import { localeOptions } from '@/i18n';

const settings = useSettingsStore();

const $q = useQuasar();

const { locale } = useI18n({ useScope: 'global' });

function toggleDarkMode() {
  $q.dark.toggle();
  settings.setDarkMode($q.dark.isActive);
}

function changeLanguage() {
  settings.setLocale(locale.value);
}
</script>
